import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const webhookTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("webhook-templates", "Webhook Templates"),
  pageNameForTracking: () => "Webhook Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("webhook-templates-description-nav", "Create and manage webhook templates"),
  icon: "nav-system-webhook-dashed",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("webhook");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
